import React from "react"
export const Icon1 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M7 16c.55 0 1 .45 1 1 0 1.1-.9 2-2 2-.17 0-.33-.02-.5-.05.31-.55.5-1.21.5-1.95 0-.55.45-1 1-1M18.67 3c-.26 0-.51.1-.71.29L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41l-1.34-1.34c-.2-.2-.45-.29-.7-.29zM7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3z" />
    </svg>
  )
}

export const Icon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z" />
    </svg>
  )
}
export const Icon3 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6m0-2C9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4z" />
    </svg>
  )
}
export const Icon4 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 20 20"
      viewBox="0 0 20 20"
      className="w-12 h-12"
      fill="#0038FF"
    >
      <g>
        <rect fill="none" height="20" width="20" x="0" />
      </g>
      <g>
        <g />
        <path d="M14.91,7.07c-0.01-0.04-0.01-0.08-0.02-0.12c-0.06-0.28-0.15-0.56-0.26-0.82c-0.02-0.05-0.04-0.09-0.06-0.14 c-0.11-0.26-0.25-0.5-0.4-0.74c-0.03-0.04-0.05-0.08-0.08-0.11c-0.16-0.23-0.34-0.46-0.55-0.66c-0.02-0.02-0.03-0.03-0.05-0.05 c-0.2-0.2-0.42-0.38-0.66-0.54c-0.02-0.02-0.04-0.03-0.06-0.05c-0.24-0.16-0.49-0.29-0.75-0.41c-0.04-0.02-0.09-0.04-0.13-0.06 c-0.26-0.11-0.53-0.19-0.81-0.25c-0.05-0.01-0.1-0.02-0.15-0.03C10.64,3.04,10.34,3.01,10.04,3C10.03,3,10.01,3,10,3 C9.9,3,9.79,3.01,9.69,3.02c-0.06,0-0.12,0-0.18,0.01C9.31,3.04,9.12,3.07,8.93,3.11c-1.94,0.4-3.49,2-3.84,3.95 c-0.31,1.72,0.26,3.3,1.33,4.4C6.78,11.84,7,12.34,7,12.87c0,0.77,0,1.6,0,2.14c0,0.55,0.45,1,1,1h0.28l0,0c0.35,0.6,0.98,1,1.72,1 s1.38-0.4,1.72-1l0,0H12c0.55,0,1-0.45,1-1v-2.13c0-0.52,0.21-1.02,0.58-1.4C14.45,10.57,15,9.35,15,8 C15,7.68,14.96,7.37,14.91,7.07z M12,15l-2,0l0,0l0,0l-2,0l0-1h4V15z M12,13H8h0l0-1h4V13z M12.86,10.77 c-0.07,0.07-0.12,0.15-0.19,0.23H7.32c-0.06-0.08-0.12-0.16-0.19-0.24c-0.91-0.94-1.3-2.22-1.06-3.52 c0.29-1.57,1.52-2.83,3.06-3.16C9.42,4.03,9.71,4,10,4c2.21,0,4,1.79,4,4C14,9.04,13.6,10.02,12.86,10.77z" />
        <g>
          <g>
            <g>
              <rect height="2.5" width="1" x="9.5" y="8.5" />
            </g>
          </g>
          <g>
            <g>
              <rect
                height="2.5"
                transform="matrix(0.7071 -0.7071 0.7071 0.7071 -2.9225 8.8839)"
                width="1"
                x="8.76"
                y="6.72"
              />
            </g>
          </g>
          <g>
            <g>
              <rect
                height="2.5"
                transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 12.6945 21.1976)"
                width="1"
                x="10.24"
                y="6.72"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
export const Icon5 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22 0 .89.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z" />
    </svg>
  )
}
export const Icon6 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12L13 9.94zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11l1.06-1.06zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z" />
    </svg>
  )
}
export const Icon7 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zm-18.31.56c-.66.37-1.29.8-1.87 1.27l-1.07-1.07c.91-.75 1.9-1.39 2.95-1.9v1.7zm15.07 1.26c-.59-.48-1.21-.9-1.87-1.27v-1.7c1.04.51 2.03 1.15 2.94 1.9l-1.07 1.07zm.69-12.23l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM11 2h2v5h-2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z" />
    </svg>
  )
}
export const Icon8 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
    </svg>
  )
}
export const Icon9 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-10 h-10"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 12c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-1.8C18 6.57 15.35 4 12 4s-6 2.57-6 6.2c0 2.34 1.95 5.44 6 9.14 4.05-3.7 6-6.8 6-9.14zM12 2c4.2 0 8 3.22 8 8.2 0 3.32-2.67 7.25-8 11.8-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2z" />
    </svg>
  )
}
export const Icon10 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-8 h-8"
      fill="#0038FF"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
    </svg>
  )
}
